/* AUVENNE final conversion layer — 2026-08-26 */
(function () {
  'use strict';

  var pendingDuos = new WeakSet();
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = (document.documentElement.lang || '').toLowerCase();
  var isSwedish = locale.indexOf('sv') === 0 || location.pathname.indexOf('/sv-se') === 0;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    (isSwedish ? 'SEK' : 'EUR');
  var copy = isSwedish ? {
    duo: 'Lägg till duon',
    adding: 'Lägger till…',
    added: 'Tillagd',
    saving: '15% rabatt',
    shipping: 'fri frakt',
    allReviews: 'Visa alla {count} omdömen',
    fewerReviews: 'Visa färre omdömen',
    cartMain: 'Lägg till 1 deltagande smycke till för 15% kombinationsrabatt.',
    cartKicker: 'MER FÖRDEL',
    cartCta: 'Välj ditt andra smycke →',
    error: 'Det gick inte att lägga till duon. Försök igen.'
  } : {
    duo: 'Voeg duo toe',
    adding: 'Wordt toegevoegd…',
    added: 'Toegevoegd',
    saving: '15% korting',
    shipping: 'gratis verzending',
    allReviews: 'Bekijk alle {count} reviews',
    fewerReviews: 'Toon minder reviews',
    cartMain: 'Voeg nog 1 deelnemend sieraad toe voor 15% combinatiekorting.',
    cartKicker: 'MEER VOORDEEL',
    cartCta: 'Kies je tweede sieraad →',
    error: 'Het duo kon niet worden toegevoegd. Probeer het opnieuw.'
  };

  function money(cents) {
    try {
      return new Intl.NumberFormat(isSwedish ? 'sv-SE' : 'nl-NL', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: currency === 'SEK' ? 0 : 2,
        maximumFractionDigits: currency === 'SEK' ? 0 : 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function parseVariantData() {
    var script = document.querySelector('script[data-lu-vdata]');
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); } catch (error) { return null; }
  }

  function selectedOptions() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-lu-opt]:checked'))
      .sort(function (a, b) { return Number(a.getAttribute('data-lu-opt')) - Number(b.getAttribute('data-lu-opt')); })
      .map(function (input) { return input.value; });
  }

  function selectedMainVariant(data) {
    if (!data || !Array.isArray(data.variants)) return null;
    var options = selectedOptions();
    return data.variants.find(function (variant) {
      return variant.available !== false && options.every(function (value, index) {
        return !value || variant.options[index] === value;
      });
    }) || data.variants.find(function (variant) { return variant.available !== false; }) || null;
  }

  function productJsonUrl(href) {
    var url = new URL(href, location.href);
    url.hash = '';
    url.search = '';
    url.pathname = url.pathname.replace(/\.js$/, '') + '.js';
    return url.toString();
  }

  function freeShippingThreshold() {
    if (currency === 'EUR') return 4500;
    if (currency === 'SEK') return 49500;
    return Number.POSITIVE_INFINITY;
  }

  function matchingPairVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var color = selectedOptions()[0];
    return product.variants.find(function (variant) {
      return variant.available && color && Array.isArray(variant.options) && variant.options.indexOf(color) !== -1;
    }) || product.variants.find(function (variant) { return variant.available; }) || null;
  }

  function setDuoError(card, message) {
    var old = card.querySelector('.auv-ad-combo__error');
    if (old) old.remove();
    if (!message) return;
    var error = document.createElement('span');
    error.className = 'auv-ad-combo__error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    card.querySelector('.auv-ad-combo__body').appendChild(error);
  }

  function initDuoCard(card) {
    if (!card || card.getAttribute('data-auv-duo-ready') === 'true' || pendingDuos.has(card)) return;
    var cta = card.querySelector('.auv-ad-combo__cta');
    var saving = card.querySelector('.auv-ad-combo__saving');
    var pairLink = card.querySelector('.auv-ad-combo__title') || cta;
    var mainData = parseVariantData();
    if (!cta || !pairLink || !mainData) return;

    pendingDuos.add(card);
    fetch(productJsonUrl(pairLink.href), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('pair-product');
        return response.json();
      })
      .then(function (pairProduct) {
        var mainVariant = selectedMainVariant(mainData);
        var pairVariant = matchingPairVariant(pairProduct);
        if (!mainVariant || !pairVariant) return;

        var mainPrice = Number(String(mainVariant.price || '').replace(/[^0-9,.-]/g, '').replace(',', '.')) * 100;
        if (!Number.isFinite(mainPrice) || mainPrice <= 0) mainPrice = Number(pairProduct.price || 0);
        var pairPrice = Number(pairVariant.price || pairProduct.price || 0);
        var duoTotal = Math.round((mainPrice + pairPrice) * 0.85);
        var hasFreeShipping = duoTotal >= freeShippingThreshold();

        cta.textContent = copy.duo + (duoTotal > 0 ? ' — ' + money(duoTotal) : '');
        cta.classList.add('is-auv-duo-ready');
        cta.setAttribute('role', 'button');
        cta.setAttribute('aria-label', cta.textContent);
        if (saving) saving.textContent = copy.saving + (hasFreeShipping ? ' + ' + copy.shipping : '');
        card.setAttribute('data-auv-duo-ready', 'true');

        cta.addEventListener('click', function (event) {
          event.preventDefault();
          if (cta.classList.contains('is-auv-loading')) return;
          var liveMain = selectedMainVariant(mainData);
          var livePair = matchingPairVariant(pairProduct);
          if (!liveMain || !livePair) return;

          cta.classList.add('is-auv-loading');
          cta.textContent = copy.adding;
          cta.setAttribute('aria-busy', 'true');
          setDuoError(card, '');

          fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
            .then(function (response) { return response.ok ? response.json() : { items: [] }; })
            .then(function (cart) {
              var existingIds = (cart.items || []).map(function (item) { return Number(item.variant_id); });
              var items = [];
              if (existingIds.indexOf(Number(liveMain.id)) === -1) items.push({ id: Number(liveMain.id), quantity: 1 });
              if (existingIds.indexOf(Number(livePair.id)) === -1) items.push({ id: Number(livePair.id), quantity: 1 });
              if (!items.length) return {};
              return fetch(rootPath + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: items })
              }).then(function (response) {
                if (!response.ok) throw new Error('cart-add');
                return response.json();
              });
            })
            .then(function (result) {
              cta.textContent = copy.added;
              if (window.AUVENNECartDrawer && typeof window.AUVENNECartDrawer.render === 'function') {
                return window.AUVENNECartDrawer.render(result || {}, cta);
              }
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open(cta);
            })
            .catch(function () {
              cta.classList.remove('is-auv-loading');
              cta.removeAttribute('aria-busy');
              cta.textContent = copy.duo + (duoTotal > 0 ? ' — ' + money(duoTotal) : '');
              setDuoError(card, copy.error);
            });
        });
      })
      .catch(function () {
        /* Keep the original product link as the safe fallback. */
      })
      .finally(function () {
        pendingDuos.delete(card);
      });
  }

  function setupReviewList(section) {
    if (!section) return;
    var list = section.querySelector('.auv-reviews__list');
    if (!list) return;

    function apply() {
      var cards = Array.prototype.slice.call(list.querySelectorAll('.auv-review-card'));
      if (cards.length <= 4) {
        var obsolete = section.querySelector('.auv-review-show-all');
        if (obsolete) obsolete.remove();
        return;
      }

      cards.forEach(function (card, index) {
        if (index >= 4) card.setAttribute('data-auv-review-extra', 'true');
        else card.removeAttribute('data-auv-review-extra');
      });

      var button = section.querySelector('.auv-review-show-all');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'auv-review-show-all';
        button.setAttribute('aria-expanded', 'false');
        list.insertAdjacentElement('afterend', button);
        button.addEventListener('click', function () {
          var expanded = section.getAttribute('data-auv-reviews-expanded') === 'true';
          section.setAttribute('data-auv-reviews-expanded', expanded ? 'false' : 'true');
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          button.textContent = expanded ? copy.allReviews.replace('{count}', cards.length) : copy.fewerReviews;
          if (expanded) section.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
      if (section.getAttribute('data-auv-reviews-expanded') !== 'true') {
        button.textContent = copy.allReviews.replace('{count}', cards.length);
      }
    }

    apply();
    new MutationObserver(apply).observe(list, { childList: true });
  }

  function combineCartBenefit(scope) {
    var area = scope && scope.querySelector ? scope : document;
    var shipping = area.querySelector('.lu-cart__shipping.auv-cart__notice');
    var stack = area.querySelector('.lu-cart__stack.auv-cart__notice');
    if (!shipping || !stack || stack.hidden || stack.textContent.indexOf('1 / 3') === -1) return;

    var kicker = shipping.querySelector('.auv-cart__notice-kicker');
    var badge = shipping.querySelector('.auv-cart__notice-badge');
    var main = shipping.querySelector('.auv-cart__notice-main');
    var second = area.querySelector('.auv-cart__second');
    if (kicker) kicker.textContent = copy.cartKicker;
    if (badge) badge.textContent = '1 / 3';
    if (main) main.textContent = copy.cartMain;
    if (second) second.textContent = copy.cartCta;
    shipping.setAttribute('data-auv-combined-benefit', 'true');
    stack.hidden = true;
  }

  function removeRepeatedHomepageBlock() {
    if (document.querySelector('.auv-why-mini')) {
      var wrapper = document.querySelector('.auv-why-mini').closest('.shopify-section');
      if (wrapper) wrapper.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll('.auv-ad-combo').forEach(initDuoCard);
    document.querySelectorAll('.auv-reviews').forEach(setupReviewList);
    combineCartBenefit(document);
    removeRepeatedHomepageBlock();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('.auv-ad-combo')) initDuoCard(node);
          node.querySelectorAll && node.querySelectorAll('.auv-ad-combo').forEach(initDuoCard);
          if (node.matches('.auv-reviews')) setupReviewList(node);
          node.querySelectorAll && node.querySelectorAll('.auv-reviews').forEach(setupReviewList);
        });
      });
      combineCartBenefit(document);
      removeRepeatedHomepageBlock();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
